<template><section class="section">
<br><br> <br><br><br><br><br>
<div id="About">
    <div class="subtitle hey">About</div>
    <hr>
    <div class="title is-2">
        <div class="he">Hey!!</div><br>

    </div>
    <div class="AboutContent"><ul>
        <li>Am Nelson 0mondi Odhiambo</li>
        <li><legend>He/Him</legend></li>
        <li>Kenyan citizen by birth</li>
        <li>Residing in Mombasa,</li>
        <li>Full stack developer and</li>
        <li>Adult chess improver</li>
        <li>Chess coach</li><br>
        </ul>
    </div>

</div></section>
</template>

    
<script>
export default {
    name: 'AboutComponent',

}
</script>

    
<style>
li{
    font-size: medium;
    font-family: monospace;
    gap: 2%;
}
.Aboutext {
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;

}

.AboutContent {
    font-size: larger;
}
.he:hover{ font-size: 350%;}

.he {
    font-size: 250%;
    text-align: left;
    padding-bottom: 5%;
    padding-left: 2%;
    color: rgb(104, 85, 61);
}
.hey {
    font-size: 250%;
    text-align: center;
    color: rgb(104, 85, 61);
}

</style>
